// /theme/mui-theme.ts
import { createTheme } from "@mui/material/styles";
const theme = createTheme({
  palette: {
    primary: {
      main: "#0A0A0A", // Button background (contained variant)
      contrastText: "#FFFFFF", // Button text color
    },
    secondary: {
      main: "#0A0A0A", // Button background (contained variant)
      contrastText: "#0A0A0A", // Button text color
    },
    // background: {
    //   default: "#F4F5F0", // Optional: default page bg
    //   paper: "#E5E4E2", // Optional: card/dialog bg
    // },
  },
  typography: {
    fontFamily: '"SF Pro", sans-serif',
  },
  // Optional: you can also override component styles here if needed
});
export default theme;